import React, {useState} from "react";
import {Select} from "grommet";
import { Country }  from 'country-state-city';

// `countries` narrows the list to those ISO codes; without it every country is offered.
const getCountryOptions = (countries) => {
    //Regions and countries excluded
    const excludedCountries = ['Antarctica','Iran','North Korea','Syria','Venezuela', 'Cuba','Turkey'];
    let countryOptions = (Country.getAllCountries()
        .filter(country => !excludedCountries.includes(country.name))
        .filter(country => !countries || countries.includes(country.isoCode))
    ).map(country => ({
        value: country.isoCode,
        label: country.name,
        testStr: country.name.toLowerCase()
    }));
    // put USA first in the list
    const USindex = countryOptions.findIndex(country => country.value === "US");
    const USobj = countryOptions.splice(USindex, 1);
    return [...USobj, ...countryOptions];
}

const CountryInput = ({
    value, onChange, countries, ...rest
}) => {
    const fullCountryOptions = getCountryOptions(countries);
    const [options, setOptions] = useState(fullCountryOptions);

    return (
        <Select
            size="medium"
            placeholder="Select country"
            value={value}
            options={options}
            onChange={(event) => onChange && onChange(event)}
            labelKey="label"
            valueKey={{ key: 'value', reduce: true }}
            onClose={() => setOptions(getCountryOptions(countries))}
            onSearch={text => { 
                if (!text) { // if user reset search string, render full set of options again
                    setOptions(fullCountryOptions);
                } 
                const escapedText = text.toLowerCase().replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
                const exp = new RegExp(escapedText, 'i');
                setOptions(fullCountryOptions.filter(option => exp.test(option.testStr)));
            }}
            {...rest}
        />
    );
};

export default CountryInput;
